<div class="container">
	<div class="script">
		<h1>Thanks for stopping by!</h1>
		<h2>Have a nice day...</h2>
		<h4><a routerLink="/login">Login here</a></h4>
	</div>
</div>
